import { convertToValidOpeningHours } from '../../../pages/adapters/convert-to-valid-opening-hours.js';
import { FRANCHISE_STORE } from '../../../types.js';

const fromStoreQueryDataToStoreDetails = (storeQueryData)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , globalStoreId , slug , name , description , storenote , email , storeDetailImage , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , metaDescription , servicesNotAvailable , features , storeFacilities , monOpenClose , tueOpenClose , wedOpenClose , thuOpenClose , friOpenClose , satOpenClose , sunOpenClose , specialOpenClosingHours , offers , hearingAppointmentPossible , wheelchairAccessible , breadcrumbName , breadcrumbSlug , practicalInformation , rating , googlePlaceId , googlePlaceReviewUrl , defaultAppointmentTypeId , shortName , appointmentsAvailable ,  } = storeQueryData;
        const storeTypes = storeQueryData.storeTypes || [];
        var ref, ref1, ref2, ref3;
        return {
            code,
            globalStoreId,
            name,
            streetName,
            town,
            country,
            phone,
            practicalInformation: practicalInformation !== null && practicalInformation !== void 0 ? practicalInformation : undefined,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            description: description !== null && description !== void 0 ? description : undefined,
            storeNote: storenote !== null && storenote !== void 0 ? storenote : undefined,
            detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            wheelchairAccessible: wheelchairAccessible !== null && wheelchairAccessible !== void 0 ? wheelchairAccessible : undefined,
            hearingAppointmentPossible: hearingAppointmentPossible !== null && hearingAppointmentPossible !== void 0 ? hearingAppointmentPossible : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            metaDescription: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
            servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : [],
            breadcrumbName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
            breadcrumbSlug: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined,
            brands: (ref = features === null || features === void 0 ? void 0 : features.availableBrands) !== null && ref !== void 0 ? ref : [],
            facilities: (storeFacilities !== null && storeFacilities !== void 0 ? storeFacilities : []).filter((entry)=>entry !== null
            ),
            openingHours: {
                monday: convertToValidOpeningHours(monOpenClose),
                tuesday: convertToValidOpeningHours(tueOpenClose),
                wednesday: convertToValidOpeningHours(wedOpenClose),
                thursday: convertToValidOpeningHours(thuOpenClose),
                friday: convertToValidOpeningHours(friOpenClose),
                saturday: convertToValidOpeningHours(satOpenClose),
                sunday: convertToValidOpeningHours(sunOpenClose)
            },
            specialOpeningHours: (specialOpenClosingHours !== null && specialOpenClosingHours !== void 0 ? specialOpenClosingHours : []).filter((entry)=>entry !== null
            ),
            paymentMethods: (ref1 = features === null || features === void 0 ? void 0 : features.paymentMethods) !== null && ref1 !== void 0 ? ref1 : [],
            socialMediaLinks: (ref2 = features === null || features === void 0 ? void 0 : features.socialMediaLinks) !== null && ref2 !== void 0 ? ref2 : undefined,
            storeProductCategories: (ref3 = features === null || features === void 0 ? void 0 : features.productCategories) !== null && ref3 !== void 0 ? ref3 : [],
            offers,
            rating: rating ? {
                value: rating.value,
                count: rating.count
            } : undefined,
            googlePlaceId: googlePlaceId !== null && googlePlaceId !== void 0 ? googlePlaceId : undefined,
            googlePlaceReviewUrl: googlePlaceReviewUrl !== null && googlePlaceReviewUrl !== void 0 ? googlePlaceReviewUrl : undefined,
            defaultAppointmentTypeId: defaultAppointmentTypeId !== null && defaultAppointmentTypeId !== void 0 ? defaultAppointmentTypeId : undefined,
            isFranchiseStore: storeTypes.includes(FRANCHISE_STORE),
            shortName,
            appointmentsAvailable
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

export { fromStoreQueryDataToStoreDetails as default, fromStoreQueryDataToStoreDetails };
//# sourceMappingURL=fromStoreQueryDataToStoreDetails.js.map
